

/**
 * Who the approval workflow is switched on for.
 *
 * `settings/general.workflowEnabled` is the firm-wide switch. While it is OFF, a named
 * pilot list (`workflowPilotUids`) can still run the real chain, so the workflow can be
 * tested end to end on real matters without every submission in the firm suddenly routing
 * for approval. When the firm-wide switch is ON, everyone gets the workflow and the list
 * is irrelevant — it can only ever ADD people, never exclude them.
 *
 * Browser copy of functions/src/lib/workflowAccess.js -- a faithful port, not a shared
 * import (functions/ deploys standalone). Keep the two in step.
 */

/** Whether a matter submitted BY `uid` should build an approval chain. */
export function workflowEnabledFor(general, uid) {
  if (general?.workflowEnabled !== false) return true; // absent/true = on, as before
  const pilots = Array.isArray(general?.workflowPilotUids) ? general.workflowPilotUids : [];
  return Boolean(uid) && pilots.includes(uid);
}

/**
 * What a matter's own record should say, preferring the decision STAMPED on it at
 * submission over the live setting.
 *
 * The stamp is what makes the record honest: the PDF and the approval trail used to read
 * the live firm-wide switch at render time, so turning the workflow off would retitle an
 * already-approved matter as a "Submission Record" and drop its Approval Trail — asserting
 * that approvals which genuinely happened never did. A per-person pilot makes that sharper
 * still (a record would change meaning when someone leaves the pilot list). Matters
 * submitted before the stamp existed fall back to the live setting, which is exactly the
 * behaviour they were created under.
 */
export function matterUsedWorkflow(matter, general) {
  if (typeof matter?.workflowEnabled === 'boolean') return matter.workflowEnabled;
  return general?.workflowEnabled !== false;
}

